export default {
  title: 'Setări',
  reservation_hours_helper: 'Aceste ore definesc când oaspeții pot face rezervări online.',
  reservation_hours_alert:
    'Orele de rezervare diferă de orele normale de deschidere. Oaspeții pot rezerva doar în intervalele afișate aici.',
  activated: 'Rezervări active',
  deactivated: 'Rezervări inactive',
  buttons: {
    activate: 'Activați',
    deactivate: 'Dezactivați',
  },
  error_messages: {
    no_google_place: {
      title: 'Restaurantul nu este conectat la nicio locație Google',
      description: 'Vă rugăm să conectați restaurantul la o locație Google',
    },
    toggle_failed: 'Rezervările nu au putut fi actualizate. Vă rugăm să încercați din nou.',
  },
};
